import React from "react";
import Navbar from "components/generales/Navbar";
import "components/generales/Styles.css";
import { Outlet } from "react-router-dom";
import finanzas from './finance_analytics.png'

import './Home.css'
import '../../components/generales/Styles.css'
// import logo from '../../components/MyMoney/logo.png'
import logo from './favicon.ico'

const Home = () => {
  return (
    <>
      <Navbar />
      <Outlet />
      <div className="contenido">
        <img className="img_finanzas" src={finanzas} alt="Ilustracion analisis de finanzas desde laptop" />
        <div className="texto">
          <h1>¡Hola!</h1>
          <p>
            Ya puedes comenzar a registrar cuentas y etiquetas personalizadas para llevar el control de tus finanzas en un solo lugar.
            <br /><img className="logoMM" src={logo} alt="logo MyMoney" />
          </p>
        </div>
      </div>
    </>
  );
};

export default Home;
